import Cookies from 'js-cookie';
import { getLoginToken } from '.';
import {
  BASE_LOGIN_COOKIE_KEY,
  getLoginCookieKey,
  isSupportSystem,
} from '../../../config';
import { getDomain } from '../../../lib';
import { getSupportCookieToken } from '../../admin/lib/ioa-helper';

export const setCookieToken = (ticket: string) => {
  const date = new Date();
  const hour = 12 * 60 * 60 * 1000; // 12小时过期
  const expireTime = Number(Date.parse(String(date)) + hour);

  const opt = {
    path: '/',
    expires: new Date(expireTime),
    domain: getDomain(),
  };
  Cookies.set(BASE_LOGIN_COOKIE_KEY, ticket, opt);
  Cookies.set(getLoginCookieKey(), ticket, opt);
};

export const removeCookieToken = () => {
  const domain = getDomain();
  const opt = {
    path: '/',
    domain,
  };
  Cookies.remove(BASE_LOGIN_COOKIE_KEY, opt);
  Cookies.remove(getLoginCookieKey(), opt);
};

export const getCookieToken = () => {
  return Cookies.get(getLoginCookieKey()) || '';
};

export const getSystemTicket = () => {
  return isSupportSystem() ? getSupportCookieToken() : getLoginToken();
};
